<template>
  <div class="number-info-body">
    <div class="number-info-title">
      <div class="number-info-content">
        <div class="number-info-input">
          <span>密码：</span>
          <a-input-password
            size="large"
            style="width: 560px"
            v-model="password"
            placeholder="长6-20位且数字、符号、字母至少包含两种"
          />
        </div>
        <div class="number-info-input">
          <span>确认密码：</span>
          <a-input-password
            size="large"
            style="width: 560px"
            v-model="confirmPassword"
            placeholder="请再次输出密码"
          />
        </div>
      </div>
    </div>
    <div class="number-info-footer">
      <a-button @click="resetSubmit">提 交</a-button>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            password:'',
            confirmPassword:''
        }
    },
    methods:{
        resetSubmit(){
            this.$message.success("修改成功!");
        }
    }
};
</script>

<style lang="less" scoped>
.number-info-content {
  height: 456px;
  padding-top: 40px;

  .number-info-input {
    display: flex;
    margin-bottom: 32px;
    justify-content: space-between;

    > span {
      width: 90px;
      line-height: 40px;
    }

    > button {
      width: 120px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      color: #1abc9c;
    }
  }
}
.number-info-body {
  height: 100%;
  width: 640px;
  margin: 0 auto;
  padding: 40px 0;

  .number-info-title {
    display: flex;
    border-bottom: 1px solid #f0f0f0;

    > span {
      flex: 1;
      height: 56px;
      line-height: 56px;
      border-bottom: 2px solid transparent;
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.3s;

      &.active {
        border-color: #1abc9c;
        color: #1abc9c;
      }
    }
  }

  .number-info-footer {
    > button {
      display: block;
      width: 100%;
      height: 48px;
      background: #1abc9c;
      border-color: #1abc9c;
      border-radius: 2px;
      font-size: 16px;
      color: #fff;
      margin-bottom: 24px;
    }

    > p {
      display: flex;
      align-items: center;

      .number-info-footer-xy {
        color: #1abc9c;
        cursor: pointer;
      }
    }
  }
}
</style>
